import esMessages from './es_ES.json';
import caMessages from './ca_ES.json';

const languages = {
  ES: esMessages,
  CA: caMessages
};

export default languages;